const MAIN_FORM_SELECTOR = '.js-product-single-actions';
const MAIN_BUTTON_SELECTOR = '.js-product-single-actions .js-product-add';
const MAIN_PRICE_SELECTOR = '.js-product-single-actions .price';

class StickyAddToCart extends HTMLElement {
  #mainButton;
  #intersectionObserver;
  #mutationObserver;
  #ticking;

  connectedCallback() {
    this.#mainButton = document.querySelector(MAIN_BUTTON_SELECTOR);

    if (!this.#mainButton) return;

    // Proxying the real button keeps variant, quantity and ajax-cart behaviour
    // in the theme's own form instead of duplicating it here.
    this.querySelector('.js-sticky-atc-add').addEventListener('click', () =>
      this.#mainButton.click(),
    );

    this.#intersectionObserver = new IntersectionObserver(([entry]) =>
      this.classList.toggle('is-visible', !entry.isIntersecting),
    );
    this.#intersectionObserver.observe(this.#mainButton);

    // VariantSelects re-renders the price and button asynchronously, so the
    // 'variants:change' event fires before the new markup lands.
    this.#mutationObserver = new MutationObserver(() => this.#scheduleSync());
    this.#mutationObserver.observe(document.querySelector(MAIN_FORM_SELECTOR), {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'class'],
    });

    document.body.classList.add('sticky-atc-enabled');
    this.#sync();
  }

  disconnectedCallback() {
    this.#intersectionObserver?.disconnect();
    this.#mutationObserver?.disconnect();
    document.body.classList.remove('sticky-atc-enabled');
  }

  #scheduleSync() {
    if (this.#ticking) return;

    // setTimeout rather than rAF: rAF is paused in background tabs, which would
    // leave the bar showing a stale price when the customer returns.
    this.#ticking = true;
    window.setTimeout(() => {
      this.#ticking = false;
      this.#sync();
    }, 0);
  }

  #sync() {
    // The theme replaces the button node on re-render, so re-resolve it.
    const mainButton = document.querySelector(MAIN_BUTTON_SELECTOR);

    if (mainButton && mainButton !== this.#mainButton) {
      this.#mainButton = mainButton;
      this.#intersectionObserver.disconnect();
      this.#intersectionObserver.observe(mainButton);
    }

    const button = this.querySelector('.js-sticky-atc-add');
    const price = this.querySelector('.js-sticky-atc-price');
    const mainPrice = document.querySelector(MAIN_PRICE_SELECTOR);

    button.disabled = this.#mainButton.disabled;
    this.querySelector('.js-sticky-atc-text').textContent =
      this.#mainButton
        .querySelector('.js-product-add-text')
        ?.textContent.trim() ?? button.textContent;

    if (!mainPrice) return;

    price.innerHTML = mainPrice.innerHTML;
    // The copy carries the main price element's ids, which VariantSelects
    // targets by id when it re-renders.
    price.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
